import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {ArrowRight} from 'lucide-react';
import PropTypes from 'prop-types';
import React from 'react';

import {DARK_TEXT_COLOR} from '../../../theme';

const styles = {
  button: {
    paddingLeft: '40px',
    paddingRight: '40px',
  },
  container: {
    paddingBottom: '4rem',
    paddingTop: '3.5rem',
  },
  emoji: {
    fontSize: '50px',
  },
  title: {
    color: DARK_TEXT_COLOR,
    fontSize: '20px',
    fontWeight: 700,
    paddingBottom: 3,
    paddingTop: 2,
  },
};

export const CompletedView = ({isIngestionComplete, onOpenReport}) => {
  if (!isIngestionComplete) {
    return null;
  }

  return (
    <Stack alignItems="center" direction="column" sx={styles.container}>
      <Typography sx={styles.emoji}>🎉</Typography>
      <Typography sx={styles.title}>Your new report is ready</Typography>
      <Button
        color="green"
        onClick={onOpenReport}
        sx={styles.button}
        variant="contained"
      >
        Open Report &nbsp;
        <ArrowRight size={12} />
      </Button>
    </Stack>
  );
};

CompletedView.propTypes = {
  isIngestionComplete: PropTypes.bool.isRequired,
  onOpenReport: PropTypes.func.isRequired,
};
